import { Link } from "react-router-dom";
import type { UpdateItem } from "@/types";

interface UpdateCardProps {
  item: UpdateItem;
  layout?: "vertical" | "horizontal";
}

export default function UpdateCard({ item, layout = "vertical" }: UpdateCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/updates/${item.id}`}
        className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-secondary-300 md:p-4"
      >
        <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 封面`}
            title={`${item.title} 动画更新 - 漫蛙2`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-secondary-700 md:text-base">
            {item.title}
          </h3>
          <p className="mt-1 text-xs text-foreground-600">
            更新至第 <span className="font-semibold text-primary-600">{item.episode}</span> 集 / 全 {item.totalEpisodes} 集
          </p>
          <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-400">
            <i className="ri-time-line"></i>
            {item.updatedAt}
            <span className="hidden sm:inline">·</span>
            <span className="hidden sm:inline">{item.weekday}更新</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/updates/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-secondary-300"
    >
      <div className="relative h-40 w-full overflow-hidden bg-background-200 md:h-44">
        <img
          src={item.cover}
          alt={`${item.title} 封面`}
          title={`${item.title} 动画更新 - 漫蛙2`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
          更新至 {item.episode} 集
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="text-base font-semibold text-foreground-950 transition-colors group-hover:text-secondary-700">
          {item.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-2">
          {item.genre.map((g) => (
            <span key={g} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800">
              {g}
            </span>
          ))}
        </div>
        <p className="mt-3 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.description}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {item.updatedAt}
          </span>
          <span>{item.weekday}</span>
        </div>
      </div>
    </Link>
  );
}